var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgValues1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424 347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cd62c5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fleck_AboutUs_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.36,15.15c-2-.48,2,.4,0,0C267.07-.5,178.66-2.49,108.55,34.78c-53,28.18-91.64,78-103.13,133C1.47,186.74.66,206.65,7.17,225,25,275.14,87.66,296.33,139.4,319.76,178.7,337.55,197.14,347.48,239,342c38.53-5,46.94-19.18,79.26-39.07,14.51-8.93,24.38-17.12,29-22.32C347.28,280.64,513.72,54.49,346.36,15.15Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgValues1);
export default __webpack_public_path__ + "static/media/bg_values_1.78263754cd7cb6ba0a34c826bc421a67.svg";
export { ForwardRef as ReactComponent };